import {ProductData} from "@/types";

interface State {
	data: ProductData[],
	dirty: boolean,
}

const state: State = {
	data: [],
	dirty: true,
}

export default state
